export function InputField({
  label,
  name,
  type,
  placeholder,
  value,
  onChange,
  autoComplete,
}: {
  label: string;
  name: string;
  type: string;
  placeholder?: string;
  value: string;
  onChange: (val: string) => void;
  autoComplete?: string;
}) {
  return (
    <label className="block">
      <span className="text-[13px] font-medium text-[#8f98a0] mb-1.5 block">
        {label}
      </span>
      <input
        name={name}
        type={type}
        required
        autoComplete={autoComplete}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full rounded-xl bg-[#0a1018] border border-[#1e3248]/80 px-4 py-2.5 text-[15px] text-[#c7d5e0] placeholder:text-[#4a5568] outline-none transition-all duration-200 focus:border-[#66c0f4]/70 focus:ring-1 focus:ring-[#66c0f4]/20 focus:bg-[#0d141e]"
        placeholder={placeholder}
      />
    </label>
  );
}
